import React, {memo} from "react";
import {SettingsProps} from "@/types/node";
import {NodeSettings} from "../../../lib/SettingsBuilder";

const Settings: React.FC<SettingsProps> = ({
  selectedNode,
  nodes,
  takeSnapshot,
  assistantType,
}) => {
  if (!selectedNode || !selectedNode.data?.settings) return null;

  return (
    <div
      className="drawer h-full w-110 bg-white border rounded-2xl"
      key={selectedNode.id}
    >
      <NodeSettings
        selectedNode={selectedNode}
        nodes={nodes}
        takeSnapshot={takeSnapshot}
        assistantType={assistantType}
      />
    </div>
  );
};

export default memo(Settings);
